import { B2B_DROPDOWN, ADD_B2BALLIANCE } from "./type"

const initialState = {
  dropDownData: [],
  allianceData: {}

}

const postB2bReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case B2B_DROPDOWN:
      return {
        ...state,
        dropDownData: payload
      }
      case ADD_B2BALLIANCE:
        return {
          ...state,
          allianceData: payload
        }
    default:
      return { ...state }
  }

}

export default postB2bReducer;